export const DESKTOP_AD_SIZE = [[970, 250]];
export const MOBILE_AD_SIZE = [
  [320, 100],
  [300, 100],
  [300, 250]
];
